import { render, staticRenderFns } from "./HandoverTakeback.vue?vue&type=template&id=34c84560&scoped=true&"
import script from "./HandoverTakeback.vue?vue&type=script&lang=js&"
export * from "./HandoverTakeback.vue?vue&type=script&lang=js&"
import style0 from "./HandoverTakeback.vue?vue&type=style&index=0&id=34c84560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c84560",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c84560')) {
      api.createRecord('34c84560', component.options)
    } else {
      api.reload('34c84560', component.options)
    }
    module.hot.accept("./HandoverTakeback.vue?vue&type=template&id=34c84560&scoped=true&", function () {
      api.rerender('34c84560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/dashboards/HandoverTakeback.vue"
export default component.exports